export const variableCategories = { // eslint-disable-line import/prefer-default-export
  institutionName: { name: 'bankingInfo', displayName: 'Banking Info' },
  websiteType: { name: 'bankingInfo', displayName: 'Banking Info' },
  coreProviderName: { name: 'bankingInfo', displayName: 'Banking Info' },
  eBankingProviderName: { name: 'bankingInfo', displayName: 'Banking Info' },
  itCommitteeName: { name: 'itCommittee', displayName: 'IT Committee' },
  minimumItCommitteeMeetingFrequency: { name: 'itCommittee', displayName: 'IT Committee' },
  itCommitteeType: { name: 'itCommittee', displayName: 'IT Committee' },
  complianceReviewType: { name: 'complianceTools', displayName: 'Compliance Tools' },
  businessContinuityPlanName: { name: 'complianceTools', displayName: 'Compliance Tools' },
  businessContinuityPlanAbbreviation: { name: 'complianceTools', displayName: 'Compliance Tools' },
  cyberAssessmentToolName: { name: 'complianceTools', displayName: 'Compliance Tools' },
  vendorManagementProgramName: { name: 'complianceTools', displayName: 'Compliance Tools' },
  incidentResponseTeamName: { name: 'incidentResponse', displayName: 'Incident Response' },
  incidentResponseTeamAbbreviation: { name: 'incidentResponse', displayName: 'Incident Response' },
  incidentResponsePlanName: { name: 'incidentResponse', displayName: 'Incident Response' },
  initialIncidentSeverityAssessmentMadeBy: { name: 'incidentResponse', displayName: 'Incident Response' },
  primaryItResource: { name: 'itSettings', displayName: 'IT Settings' },
  secondaryItResource: { name: 'itSettings', displayName: 'IT Settings' },
  tertiaryItResource: { name: 'itSettings', displayName: 'IT Settings' },
  networkPasswordExpiration: { name: 'itSettings', displayName: 'IT Settings' },
  corePasswordExpiration: { name: 'itSettings', displayName: 'IT Settings' },
  itRiskAppetiteLevelIsFocused: { name: 'itSettings', displayName: 'IT Settings' },
};
